import { type JSX, splitProps } from 'solid-js'
import { cn } from '../lib/cn.ts'
import { tv } from '../lib/tv.ts'

/**
 * A keyboard hint. Present wherever a shortcut exists, because a shortcut nobody can see is a
 * shortcut nobody uses — and in a tool people spend a shift in, the keyboard is the difference
 * between fast and tolerable.
 */
const kbd = tv({
  base: [
    'inline-flex h-5 min-w-5 items-center justify-center rounded-[0.25rem] px-1',
    'border border-border bg-surface-muted font-mono text-micro font-medium text-text-subtle',
  ],
})

export type KbdProps = JSX.HTMLAttributes<HTMLElement>

export const Kbd = (props: KbdProps) => {
  const [local, rest] = splitProps(props, ['class'])

  return <kbd {...rest} class={cn(kbd(), local.class)} />
}
